module.exports = __webpack_public_path__ + "assets/media/level8-user-icon.218cd93b.png";